<table aria-hidden="true" *ngIf="riskMatrix && gridCols.length > 0 && gridRows.length > 0" class="risk-matrix-table" cellpadding="0" cellspacing="0">
  <thead>
    <tr>
      <th scope="col"></th>
      <th scope="col"></th>
      <th scope="col" [colSpan]="gridCols.length" class="matrix-table-cell">
        <div class="header">
          <span class="risk-matrix-title">
            {{ riskMatrix.name }}
          </span>
        </div>
      </th>
    </tr>
    <tr>
      <th scope="col"></th>
      <th scope="col"></th>
      <th scope="col" [colSpan]="gridCols.length">
        <div class="header">
          {{ getXAxisLabel() }}
        </div>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of gridRows">
      <td *ngIf="row.index === 0" [rowSpan]="gridRows.length" class="matrix-table-cell">
        <div class="y-axis-title">
          <div class="y-axis-title-rotate">
            {{ getYAxisLabel() }}
          </div>
        </div>
      </td>
      <td (click)="rowLabelClicked($event, row)" class="y-axis-row-label" [ngClass]="{ editable: isEditable }">
        <div>
          {{ getYAxisRowLabel(row) }}
        </div>
      </td>
      <td *ngFor="let column of gridCols" class="matrix-box">
        <div
          class="matrix-cell"
          (click)="cellClicked($event, getCell(column, row))"
          [style.background-color]="getRiskBandColor(column, row)"
          [ngClass]="{ editable: isEditable }"
        >
          <div *ngIf="drawCircle && row.id == rowVectorId && column.id == colVectorId" class="circle1">
            <span *ngIf="getCell(column, row).label" class="alignSpanInsideDiv">
              {{ getCell(column, row).label }}
            </span>
          </div>

          <div *ngIf="row.id != rowVectorId || column.id != colVectorId" [ngStyle]="{ display: display }">
            <span *ngIf="!useFrl && getCell(column, row).label" class="matrix-cell-label">
              {{ getCell(column, row).label }}
            </span>
            <span *ngIf="displayFrlCell(column, row)" class="matrix-cell-label">
              {{ getFrlCell(column, row)?.value }}
            </span>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td></td>
      <td></td>
      <td
        *ngFor="let column of gridCols"
        (click)="columnLabelClicked($event, column)"
        class="rotate-column-label"
        [ngClass]="{ editable: isEditable }"
      >
        <div>
          <span [title]="getXAxisColumnLabel(column)">{{ getXAxisColumnLabel(column) | xAxisLabel }}</span>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
